import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";

import {ESampleCopiableValues, IErrorChannels} from "./models";

import DropdownButton from "@toolbox/button-like/DropdownButton";
import T from "@translate/T";

interface ICopyProps {
    value: IErrorChannels;
    cellStampTitle: JSX.Element;

    needNorm?: boolean;

    onCopied(source: IErrorChannels, value: ESampleCopiableValues): void;
}

class Copy extends React.PureComponent<ICopyProps> {
    @boundMethod
    public copyName(e: React.SyntheticEvent) {
        e.preventDefault();

        const {onCopied, value} = this.props;
        onCopied(value, ESampleCopiableValues.Name);
    }

    @boundMethod
    public copyCellTypeStamp(e: React.SyntheticEvent) {
        e.preventDefault();

        const {onCopied, value} = this.props;
        onCopied(value, ESampleCopiableValues.CellTypeStamp);
    }

    @boundMethod
    public copyNorm(e: React.SyntheticEvent) {
        e.preventDefault();

        const {onCopied, value} = this.props;
        onCopied(value, ESampleCopiableValues.Norm);
    }

    @boundMethod
    public copyNotes(e: React.SyntheticEvent) {
        e.preventDefault();

        const {onCopied, value} = this.props;
        onCopied(value, ESampleCopiableValues.Notes);
    }

    @boundMethod
    public copyAll(e: React.SyntheticEvent) {
        e.preventDefault();

        const {onCopied, value} = this.props;
        onCopied(value, ESampleCopiableValues.All);
    }

    public render() {
        const {position} = this.props.value;
        const id = "copy-sample-" + position;

        return (
            <DropdownButton
                type="primary"
                idSuffix={id}
                standAloneButton={true}
                isButtonGroup={true}
                menu={this.renderMenu}
            >
                <FontAwesomeIcon icon={faCopy} fixedWidth={true} />
            </DropdownButton>
        );
    }

    @boundMethod
    private renderMenu() {
        const {value, cellStampTitle, needNorm} = this.props;

        return (
            <React.Fragment>
                <h6 className="dropdown-header">
                    <T>Apply to all</T>
                </h6>
                <button
                    type="button"
                    className="dropdown-item"
                    id={"same-cell-stamp-" + value.position}
                    onClick={this.copyCellTypeStamp}
                >
                    {cellStampTitle}
                </button>
                {!!needNorm && (
                    <button
                        type="button"
                        className="dropdown-item"
                        id={"same-cell-norm-" + value.position}
                        onClick={this.copyNorm}
                    >
                        <T>Normalization type</T>
                    </button>
                )}
                <button
                    type="button"
                    className="dropdown-item"
                    id={"same-name-" + value.position}
                    onClick={this.copyName}
                >
                    <T>Sample name</T>
                </button>
                <button
                    type="button"
                    className="dropdown-item"
                    id={"same-notes-" + value.position}
                    onClick={this.copyNotes}
                >
                    <T>Notes</T>
                </button>
                <button
                    type="button"
                    className="dropdown-item"
                    id={"same-all-" + value.position}
                    onClick={this.copyAll}
                >
                    <T>All values</T>
                </button>
            </React.Fragment>
        );
    }
}

export default Copy;
